import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const DynamicQuestionsModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "dynamic-questions" */
            './'
        )
    ),
    componentName: 'DynamicQuestions',
    placeholder: {
        placeholderType: 'Block',
        size: 'md',
    },
});

DynamicQuestionsModule.displayName = 'DynamicQuestionsModule';

export default DynamicQuestionsModule;
